<template>
  <div class="webrtc-player">
    <video ref="video" class="webrtc-video" autoplay playsinline muted></video>
    <div v-if="error" class="player-error">
      <i class="el-icon-warning-outline"></i>
      <span>{{ error }}</span>
    </div>
    <div v-else-if="loading" class="player-loading">
      <i class="el-icon-loading"></i>
      <span>视频连接中...</span>
    </div>
  </div>
</template>

<script>
function loadZlmScript() {
  if (window.ZLMRTCClient) {
    return Promise.resolve()
  }
  return new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-zlm-client]')
    if (existing) {
      existing.addEventListener('load', () => resolve())
      existing.addEventListener('error', () => reject(new Error('ZLMRTCClient 加载失败')))
      return
    }
    const script = document.createElement('script')
    script.src = '/js/ZLMRTCClient.js'
    script.setAttribute('data-zlm-client', '1')
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('请先将 ZLMRTCClient.js 放到 public/js/ 目录'))
    document.head.appendChild(script)
  })
}

export default {
  name: 'ZlmWebRtcPlayer',
  props: {
    playInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      error: '',
      player: null
    }
  },
  watch: {
    playInfo: {
      immediate: true,
      handler(info) {
        if (info && info.webrtcUrl) {
          this.startPlay(info)
        } else {
          this.stopPlay()
        }
      }
    }
  },
  beforeDestroy() {
    this.stopPlay()
  },
  methods: {
    async startPlay(info) {
      this.stopPlay()
      this.loading = true
      this.error = ''
      try {
        await loadZlmScript()
        const url = info.webrtcUrl
        this.player = new window.ZLMRTCClient.Endpoint({
          element: this.$refs.video,
          debug: false,
          zlmsdpUrl: url,
          simulcast: false,
          useCamera: false,
          audioEnable: false,
          videoEnable: true,
          recvOnly: true
        })
        this.player.on(window.ZLMRTCClient.Events.WEBRTC_OFFER_ANWSER_EXCHANGE_FAILED, () => {
          this.error = 'WebRTC 协商失败'
        })
        this.player.on(window.ZLMRTCClient.Events.WEBRTC_ICE_CANDIDATE_ERROR, () => {
          this.error = 'ICE 连接失败'
        })
      } catch (e) {
        this.error = e.message || '视频播放失败'
      } finally {
        this.loading = false
      }
    },

    stopPlay() {
      if (this.player) {
        try {
          this.player.close()
        } catch (e) {
          // ignore
        }
        this.player = null
      }
      if (this.$refs.video) {
        this.$refs.video.srcObject = null
      }
    },

    captureFrame() {
      const video = this.$refs.video
      if (!video || !video.videoWidth) {
        throw new Error('视频尚未就绪，无法拍照')
      }
      const canvas = document.createElement('canvas')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      const ctx = canvas.getContext('2d')
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
      return new Promise((resolve, reject) => {
        canvas.toBlob(blob => {
          if (!blob) {
            reject(new Error('抓帧失败'))
            return
          }
          resolve(blob)
        }, 'image/jpeg', 0.92)
      })
    }
  }
}
</script>

<style scoped>
.webrtc-player {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  background: #111;
  border-radius: 8px;
  overflow: hidden;
}

.webrtc-video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

.player-error,
.player-loading {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #fff;
  background: rgba(0, 0, 0, 0.55);
  font-size: 14px;
}
</style>
